import React, {useEffect} from 'react';
import {useStoreActions, useStoreState} from '~/store';
import usePageTitle from "~/app/hooks/usePageTitle";
import {useAppHeader} from "~/app/modules/appHeader";
import useTranslation from "~/app/hooks/useTranslation";
import {ROUTES} from "~/app/Router";
import classes from './style.module.scss';
import {isCordova} from "~/cordova";

export type InstructionsComponent = React.FC

const AboutUs: InstructionsComponent = () => {
    const {setData} = useAppHeader();
    const {t} = useTranslation("aboutUs");
    usePageTitle(t('title'));

    const extensionTenantId = useStoreState(state => state.user.tokenData?.extension_tenantid);
    const allTenants = useStoreState(state => state.app.appData.allTenants);
    const fetchAllTenants = useStoreActions(actions => actions.app.appData.fetchAllTenants);
    const networkStatus = useStoreState(state => state.app.offline.status);

    useEffect(() => {
        setData({
            title: t('title'),
            subTitle: '',
            backLink: ROUTES.projects,
            showUser: false,
            machineId: '',
            projectId: '',
            showMachineMessages: false,
            isIssueDetailPage: false,
            isServiceDetailPage: false,
            notification: false,
            search: false
        });
    }, [setData, t]);

    useEffect(() => {
        if(!allTenants.length && !networkStatus) {
            fetchAllTenants();
        }
    }, [extensionTenantId, allTenants, fetchAllTenants, networkStatus]);

    const handleOpenIOS = () => {
        try {
            // Try opening directly in App Store app
            window['cordova'].InAppBrowser.open(
                'itms-apps://itunes.apple.com/app/id1547223744',
                '_system'
            );
        } catch (e) {
            // Fallback to browser link
            window['cordova'].InAppBrowser.open(
                'https://apps.apple.com/app/id1547223744',
                '_system'
            );
        }
    }

    const handleOpenANDROID = () => {
        try {
            // Try opening directly in play Store app
            window['cordova'].InAppBrowser.open(
              'market://details?id=com.onlinelog.driverapp',
              '_system'
            );
        } catch (e) {
            // fallback to web
            window['cordova'].InAppBrowser.open(
              'https://play.google.com/store/apps/details?id=com.onlinelog.driverapp',
              '_system'
            );
        }
    }

    return (
        <div className={classes['aboutUs']}>
            <h1>Barde Felt</h1>
            {!!allTenants.length && <h3>Tenant: {allTenants.find(tenant => tenant.id === extensionTenantId)?.name || ""}</h3>}
            {isCordova && <h3>Versjon: {window['BuildInfo']?.version} ({window['BuildInfo']?.versionCode})</h3>}
            {window['cordova']?.platformId === 'ios' && (<div><button  onClick={handleOpenIOS} >Upgrade IOS App</button ></div>)}
            {window['cordova']?.platformId === 'android' && (<div><button onClick={handleOpenANDROID} >Upgrade Android App</button></div>)}

        </div>
    );
};

export default AboutUs
